import React from "react";
import "../../styles/components/marketplace-shared.css";

const EmptyStateCard = ({ icon, title, description, spin = false, className = "" }) => (
  <div className={`marketplace-empty-state ${className}`.trim()}>
    <span className="marketplace-empty-state__icon">
      <i className={`fa ${icon}${spin ? " fa-spin" : ""}`}></i>
    </span>
    <h4 className="marketplace-empty-state__title">{title}</h4>
    <p className="marketplace-empty-state__description">{description}</p>
  </div>
);

export default EmptyStateCard;


